




import Vue from 'vue';
import Component from 'vue-class-component';

import NotFoundImpl from '@/components/NotFoundImpl.vue';

@Component({
  components: {
    'not-found-impl': NotFoundImpl
  }
})
export default class NotFound extends Vue {

}
